"use client";

import { useState } from "react";
import { useTranslations } from "@/providers/TranslationsProvider";
import Button from "@/components/Button";

export default function ErrorMessage({
  error,
}: {
  error: string;
}) {
  const { t } = useTranslations();
  const [loading, setLoading] = useState(false);

  const handleRetry = () => {
    setLoading(true);
    window.location.reload();
  };

  return (
    <div className="max-w-md mx-auto mt-20 p-10 flex flex-col items-center bg-white dark:bg-[#1C1C1E] border border-black/[0.05] dark:border-white/[0.05] rounded-[3rem] shadow-[0_32px_64px_-16px_rgba(0,0,0,0.1)] animate-fade-in relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-1 bg-[#FF3B30]"></div>
      
      <div className="relative mb-8">
        <div className="w-20 h-20 bg-gradient-to-br from-[#FF3B30]/20 to-[#FF3B30]/5 dark:from-[#FF453A]/30 dark:to-[#FF453A]/10 rounded-3xl flex items-center justify-center border border-[#FF3B30]/20 shadow-sm relative z-10">
          <svg
            className="w-9 h-9 text-[#FF3B30] dark:text-[#FF453A]"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>
        <div className="absolute inset-0 bg-[#FF3B30] blur-3xl opacity-10 animate-pulse"></div>
      </div>
      
      <div className="text-center mb-10">
        <h3 className="text-2xl font-bold text-[#1D1D1F] dark:text-[#F5F5F7] mb-3 tracking-tight">
          {t("error.title", "Something went wrong")}
        </h3>
        <p className="text-[15px] text-[#6E6E73] dark:text-[#86868B] max-w-sm font-medium leading-relaxed">
          {error}
        </p>
      </div>

      <Button
        onClick={handleRetry}
        loading={loading}
        variant="theme"
        className="px-12 py-4 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 font-bold"
      >
        {t("buttons.retry", "Try Again")}
      </Button>
    </div>
  );
}
